import UserMenuButton from './UserMenuButton';
import UserMenuButtonContainer from './UserMenuButton.container';

export default UserMenuButtonContainer(UserMenuButton);
